/**
 * Cart-icon bounce on add/remove — Lovable Header.tsx:60-67 + :164-167 parity.
 *
 * Replicates the cart-icon scale+rotate bounce that fires when the cart's
 * itemCount changes and remains > 0. Subscribes to PUB_SUB_EVENTS.cartUpdate
 * site-wide. Add-source events always bounce (adds can't leave cart empty).
 * Remove-source events bounce only when cart still has items after the change.
 *
 * Also fires a one-shot scale+rotate pop on the .cart-count-bubble when it
 * transitions empty→present (Lovable AnimatePresence initial-only semantic).
 * Exit animation (cart→empty) is deferred — see MEMORY-ACTIVE.
 */
(function () {
  'use strict';

  var ADD_SOURCES = ['product-form', 'pick-mix', 'quick-add'];
  var BOUNCE_MS = 600;
  var POP_MS = 300;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function shouldBounce(event) {
    if (!event || !event.source) return false;
    if (event.source === 'cart-items') {
      // /cart/change.js response reliably carries full cart state.
      // Bounce only if items remain (matches Lovable's `if (itemCount > 0)`).
      return event.cartData && event.cartData.item_count > 0;
    }
    // Add sources: count is guaranteed > 0 after an add.
    return ADD_SOURCES.indexOf(event.source) !== -1;
  }

  function bubblePresent() {
    return !!document.querySelector('#cart-icon-bubble .cart-count-bubble');
  }

  function bounceIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('is-bouncing');
    void icon.offsetWidth; // force reflow so re-add re-fires the animation
    icon.classList.add('is-bouncing');
    setTimeout(function () { icon.classList.remove('is-bouncing'); }, BOUNCE_MS);
  }

  function popBubbleIfFirstAppear(wasEmpty) {
    if (!wasEmpty) return;
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('is-popping');
    void bubble.offsetWidth;
    bubble.classList.add('is-popping');
    setTimeout(function () { bubble.classList.remove('is-popping'); }, POP_MS);
  }

  ready(function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!shouldBounce(event)) return;

      // Snapshot bubble state BEFORE section re-render swaps it in.
      var wasEmpty = !bubblePresent();

      // Defer to next frame so any section-rendering finishes first; otherwise
      // our class can be wiped by the DOM swap.
      requestAnimationFrame(function () {
        bounceIcon();
        popBubbleIfFirstAppear(wasEmpty);
      });
    });
  });
})();
